export default {
      id: "cakes-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "img/icons.svg#cakes",
      toString: function () {
        return this.url;
      }
    }